import { makeStyles } from '@eagleview/ev-comp-library';

const useStyles = makeStyles(() => ({
  editButton: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  datePickerWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
  },
  datePicker: {
    position: 'absolute',
    left: '340px',
    top: '0',
    zIndex: 1300,
    transform: 'none !important',
  },
}));

export default useStyles;
